import axiosClient from './axiosClient';

export const newsService = {
    // Chỉ giữ lại các hàm lấy dữ liệu Public cho Khách hàng
    getPublicNews: () => axiosClient.get('/public/news'),
    getNewsDetail: (id) => axiosClient.get(`/public/news/${id}`),
};

export const newsCategoryService = {
    // Chỉ giữ lại API Public
    getPublicCategories: () => axiosClient.get('/public/news-categories'),
};

export const advertiseService = {
    // Chỉ giữ lại API Public
    getPublicAdvertises: () => axiosClient.get('/public/advertises'),
};